var map = {
	"./BOOST.svg": 2405,
	"./GRAB.svg": 2406,
	"./MBB.svg": 2407,
	"./TNG.svg": 2408,
	"./direpay.svg": 2409,
	"./doitnow.svg": 2410,
	"./duitnow.svg": 2411,
	"./fpay.svg": 2412,
	"./fpay2.svg": 2413,
	"./fpx.svg": 2414,
	"./online_banking.svg": 2415,
	"./rapidpays.svg": 2416,
	"./secret_pay.svg": 2417,
	"./secret_pay_offline.svg": 2418,
	"./secret_pay_pro.svg": 2419,
	"./secret_pay_pro_b.svg": 2420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;